import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.extras, { all: 1 });
}
export function createExtra(request) {
    return post(EndPoints.extrasCreate, request);
}
export function updateExtra(request) {
    return patch(EndPoints.extrasUpdate, request);
}
export function deleteExtra(request) {
    return del(EndPoints.extrasDelete, request);
}
